export const cardColors = ['rgb(0, 26, 129)', 'rgb(65, 85, 192)', 'rgb(51, 51, 51)'];
